import Users from './users.vue'
import Settings from './settings'
import Analytics from './settings/analytics/analytics.vue'
import $tenants from 'stores/tenants.js'
import $profile from 'stores/profile.js'

import $global from 'stores/global'

const __default__ = {
  data: function() {
    return {
      tenant: undefined,
      loading: true
    }
  },
  computed: {
    tabs() {
      const tabs = [
        {value: 'users', title: 'Users'},
        {value: 'analytics', title: 'Analytics'},
        {value: 'settings', title: 'Settings'}
      ]
      return tabs
    },
    active: {
      get(){
        return this.$route.query.tab
      },
      set(val){
        $global.goToAnalyticsTenant(val)
      }
    },
    tenant_name() {
      return this.tenant?.name
    }
  },
  beforeMount(){
    const {tab} = this.$route.query
    if ((tab === 'stats' || tab === 'usage_reports')) {
      $global.goToAnalyticsTenant('analytics', {replace: true})
      return
    }
    if (tab && this.tabs.some(x => x.value === tab)) return
    $global.goToAnalyticsTenant('users', {replace: true})
  },
  async mounted() {
    try {
      if (!$profile.is_admin && !$profile.is_tenant_manager) {
        $global.goToChats()
        return
      }
      if (!$profile.tenant_id) return
      this.tenant = await $tenants.loadTenant($profile.tenant_id)
    } finally {
      this.loading = false
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'tenant',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get $global() { return $global }, Users, get Settings() { return Settings }, Analytics, get $tenants() { return $tenants }, get $profile() { return $profile } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})